import { Contact } from '@/app/network/models/contact';
import { Button } from '@/common/components/button';
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle
} from '@/common/components/drawer';
import { useDisclosure } from '@/common/hooks/use-disclosure';
import { CreateUpdateContactForm } from '@/contacts/components/create-update-contact-form';
import { useCreateUpdateContactForm } from '@/contacts/hooks/use-create-update-contact-form';
import { useUpdateContact } from '@/contacts/queries';

export function UpdateContact({ contact }: { contact: Contact }) {
  const { isOpen, open, close } = useDisclosure();
  const updateContactMutation = useUpdateContact();

  const defaultValues = {
    client: contact.client ?? null!,
    firstName: contact.firstName,
    lastName: contact.lastName,
    title: contact.title ?? '',
    email: contact.email ?? '',
    workPhone: contact.workPhone ?? '',
    mobilePhone: contact.mobilePhone ?? '',
    addressLine1: contact.addressLine1 ?? '',
    addressLine2: contact.addressLine2 ?? '',
    city: contact.city ?? '',
    state: contact.state?.code ?? '',
    zipCode: contact.zipCode ?? ''
  };

  const form = useCreateUpdateContactForm({
    defaultValues,
    onSubmit: async (values) => {
      await updateContactMutation.mutateAsync(
        { data: { ...values, clientId: values.client?.id, id: contact.id } },
        { onSuccess: () => close() }
      );
    }
  });

  const handleClose = () => {
    form.reset();
    close();
  };

  return (
    <>
      <Button onClick={open}>Edit</Button>
      <Drawer open={isOpen} onClose={handleClose}>
        <DrawerContent>
          <DrawerHeader>
            <DrawerTitle>Edit Contact</DrawerTitle>
          </DrawerHeader>
          <DrawerBody>
            <CreateUpdateContactForm form={form} formId="update-contact-form" />
          </DrawerBody>
          <DrawerFooter className="gap-3">
            <form.AppForm>
              <form.FormButton outline onClick={handleClose}>Cancel</form.FormButton>
              <form.FormButton type="submit" form="update-contact-form">Update Contact</form.FormButton>
            </form.AppForm>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}
